import { z } from 'zod';
export const RoleCodeSchema = z.enum(['CLIENT', 'ADMIN', 'STAFF']);
export const OrderStatusSchema = z.enum([
    'PENDING_PAYMENT',
    'PAID',
    'PROCESSING',
    'PARTIAL',
    'COMPLETED',
    'CANCELLED',
    'REFUNDED',
    'FAILED',
]);
export const PaymentMethodSchema = z.enum(['PIX', 'CARD']);
export const PaymentStatusSchema = z.enum([
    'PENDING',
    'WAITING_PAYMENT',
    'PAID',
    'FAILED',
    'EXPIRED',
    'REFUNDED',
    'PARTIALLY_REFUNDED',
]);
export const FulfillmentStatusSchema = z.enum([
    'QUEUED',
    'PROCESSING',
    'PARTIAL',
    'COMPLETED',
    'FAILED',
    'RETRYING',
    'DEAD_LETTER',
]);
export const RegisterSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).max(128),
    name: z.string().min(2).max(120),
});
export const ConfirmRegisterSchema = RegisterSchema.extend({
    code: z.string().regex(/^\d{6}$/, 'Código deve ter 6 dígitos'),
});
export const ResendRegisterOtpSchema = z.object({
    email: z.string().email(),
});
export const LoginSchema = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const AddCartItemSchema = z
    .object({
    productId: z.string().uuid().optional(),
    kitId: z.string().uuid().optional(),
    quantity: z.number().int().positive(),
    targetUrl: z.string().url().optional(),
})
    .refine((d) => Boolean(d.productId || d.kitId), {
    message: 'productId or kitId required',
});
export const QuoteCheckoutSchema = z.object({
    cartId: z.string().uuid(),
    orderBumpProductId: z.string().uuid().optional(),
});
/** BR mobile/landline digits (10–11) after stripping non-digits. */
export const PhoneSchema = z
    .string()
    .min(8)
    .max(20)
    .refine((v) => {
    const digits = v.replace(/\D/g, '');
    return digits.length >= 10 && digits.length <= 13;
}, 'Telefone inválido');
export const PlaceOrderSchema = z
    .object({
    cartId: z.string().uuid(),
    email: z.string().email().optional().or(z.literal('')),
    phone: PhoneSchema.optional().or(z.literal('')),
    name: z.string().min(2).max(120).optional().or(z.literal('')),
    cpf: z
        .string()
        .min(11)
        .max(18)
        .transform((v) => v.replace(/\D/g, ''))
        .refine((v) => v.length === 11, 'CPF inválido'),
    paymentMethod: PaymentMethodSchema,
    installments: z.number().int().min(1).max(12).optional(),
    orderBumpProductId: z.string().uuid().optional(),
    card: z
        .object({
        number: z.string().min(13).max(23),
        holderName: z.string().min(2).max(64),
        expiryMonth: z
            .string()
            .regex(/^\d{2}$/, 'Mês inválido'),
        expiryYear: z
            .string()
            .regex(/^\d{2,4}$/, 'Ano inválido'),
        cvv: z
            .string()
            .regex(/^\d{3,4}$/, 'CVV inválido'),
        postalCode: z
            .string()
            .min(8)
            .max(10)
            .transform((v) => v.replace(/\D/g, ''))
            .refine((v) => v.length === 8, 'CEP inválido'),
        addressNumber: z.string().min(1).max(20),
    })
        .optional(),
})
    .superRefine((data, ctx) => {
    if (data.paymentMethod === 'CARD' && !data.card) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['card'],
            message: 'Dados do cartão são obrigatórios',
        });
    }
});
export const ProductPublicSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    slug: z.string(),
    description: z.string(),
    priceCents: z.string(),
    promoPriceCents: z.string().nullable(),
    networkSlug: z.string(),
    networkName: z.string().optional(),
    networkIcon: z.string().optional(),
    serviceTypeSlug: z.string(),
    imageUrl: z.string().nullable(),
    minQty: z.number(),
    maxQty: z.number(),
});
//# sourceMappingURL=index.js.map